




import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ProfileIcon extends Vue {
  @Prop({ type: String, default: '' }) readonly profileURL!: string
  get profileImage(): string {
    if (this.profileURL) {
      return this.profileURL
    }
    return 'img/default-profile.png'
  }
}
